import type {FC} from 'react';
import React, {useId} from 'react';

import classNames from 'classnames';

import {StateButton} from '@pb/kit-component-state-button';
import {Label} from '@pb/kit-component-label';

import {TimeInput} from './time-input';

import styles from './time-input.module.styl';

interface TimeInputWithToggleProps {
    timeFormat?: string,
    date?: Date,
    value?: string | Date,
    onChange?: (time: string) => void,
    includeTime?: boolean,
    onToggleChange?: () => void,
}

export const TimeInputWithToggle: FC<TimeInputWithToggleProps> = ({
    timeFormat,
    value,
    onChange,
    includeTime,
    onToggleChange,
}) => {
    const id = useId();

    const separator = classNames(styles.timeSeparator);
    const containerClassNames = classNames(styles.timeInputToggleContainer);
    const stateButtonClassNames = classNames(styles.timeStateButton);
    const switchClassNames = classNames(styles.timeSwitch);

    return (
        <>
            <div className={separator}/>

            <div className={containerClassNames}>
                <div className={stateButtonClassNames}>
                    <StateButton
                        id={id}
                        className={switchClassNames}
                        checked={includeTime}
                        onChange={onToggleChange}
                    />

                    <Label htmlFor={id}>
                        Include Time
                    </Label>
                </div>

                {includeTime ? (
                    <TimeInput
                        timeFormat={timeFormat}
                        value={value}
                        onChange={onChange}
                    />
                ) : null}
            </div>
        </>
    );
};

TimeInputWithToggle.displayName = 'TimeInputWithToggle';

